export const types = {
  authLogin: "[auth] Login",
  authStartRegister: "[auth] Start Register",
  authStartTokenRenew: "[auth] Start token renew",
  authEmpleadoSetActive: "[auth] Empleado Set Active",

  authUsuarioChecking: "[usuario] Auth Usuario checking",
  authUsuarioChecked: "[usuario] Auth Usuario checked",

  authUsuarioSetActive: "[usuario] usuario Set Active",
  authUsuarioClearActive: "[usuario] usuario Clear Active",
  authUsuarioLoginSetActive: "[usuario] usuario Login Set Active",
  authUsuarioLoginClearActive: "[usuario] usuario Login Clear Active",
  authUsuarioSetPaths: "[usuario] usuario set paths",

  authStatusLoading: "[usuario] status Loading",
  authUsuariosLoaded: "[usuario] usuarios Loaded",
  authUsuarioAdded: "[usuario] usuario added",
  authUsuarioUpdated: "[usuario] usuario updated",
  authUsuarioDeleted: "[usuario] usuario deleted",
  authUsuarioLogout: "[usuario] usuario logout",
  authUsuarioShowForm: "[usuario] Show or Close Form Usuario",

  authModulosLoaded: "[auth] modulos Loaded",
  authModuloAdded: "[auth] modulo added",
  authModuloUpdated: "[auth] modulo updated",
  authModuloDeleted: "[auth] modulo deleted",
  authModuloSetActive: "[auth] modulo Set Active",
  authModuloClearActive: "[auth] modulo Clear Active",

  authRutaSetActive: "[auth] ruta Set Active",
  authRutaClearActive: "[auth] ruta Clear Active",
  authRutaAdded: "[auth] ruta added",
  authRutaUpdated: "[auth] ruta updated",
  authRutaDeleted: "[auth] ruta deleted",

  authRutasModuloSetActive: "[auth] rutas modulo Set Active",
  authRutasModuloClearActive: "[auth] rutas modulo Clear Active",

  authPerfilesLoaded: "[auth] perfiles Loaded",
  authPerfilAdded: "[auth] perfil added",
  authPerfilUpdated: "[auth] perfil updated",
  authPerfilDeleted: "[auth] perfil deleted",
  authPerfilSetActive: "[auth] perfil Set Active",
  authPerfilClearActive: "[auth] perfil Clear Active",
};
